import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TableScrollService {
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;

  // Start dragging method
  startDrag(event: MouseEvent, tableContainer: HTMLElement): void {
    this.isDragging = true;
    this.startX = event.pageX - tableContainer.offsetLeft;
    this.startY = event.pageY - tableContainer.offsetTop;
    this.scrollLeft = tableContainer.scrollLeft;
    this.scrollTop = tableContainer.scrollTop;
    tableContainer.style.cursor = 'grabbing';
  }

  // On mouse move method
  onDrag(event: MouseEvent, tableContainer: HTMLElement): void {
    if (!this.isDragging) return;
    event.preventDefault();

    const multiplier = 2.3;
    const moveX = (event.pageX - this.startX) * multiplier;
    const moveY = (event.pageY - this.startY) * multiplier;

    tableContainer.scrollLeft = this.scrollLeft - moveX;
    tableContainer.scrollTop = this.scrollTop - moveY;
  }

  // Stop dragging method
  stopDrag(tableContainer: HTMLElement): void {
    this.isDragging = false;
    tableContainer.style.cursor = 'grab';
  }

  handleHorizontalScroll(event: WheelEvent, tableContainer: HTMLElement): void {
    event.preventDefault();
    tableContainer.scrollLeft += event.deltaY;
  }
}
